<ng-content select="[comp-dialog-footer-inner]"></ng-content>
